import { createRouter, createWebHistory } from 'vue-router'
import homeView from '../views/homeView.vue'
import enView from '../views/enView.vue'
import esView from '../views/esView.vue'
import loginView from '../views/loginView.vue'
import categoryView from '../views/categoryView.vue'
import nicView from '../views/nicView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: homeView
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // },
  {
    path: '/es',
    name: 'es',
    component : esView   
  },
  {
    path: '/en',
    name: 'en',
    component: enView,
  },
  {
    path: '/category',
    name: 'category',
    component: categoryView,
  },
  {
    path: '/nic',
    name: 'nic',
    component: nicView,
  },
  {
    path: '/login',
    name: 'login',
    component: loginView,
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router